<div class="font-roboto-400 text-blue-o-50 animate-pulse">
  @for (_ of [1, 2, 3, 4, 5]; track $index) {
  <div class="flex border-b border-grey-5 py-3 min-h-[70px] items-center gap-4">
    <!-- Player logo -->
    <div
      class="w-[60px] h-[60px] rounded-full bg-grey-skeleton max-sm:w-[30px] max-sm:h-[30px]"
    ></div>

    <!-- Shirt number -->
    <div class="w-[30px] h-[20px] bg-grey-skeleton rounded"></div>

    <!-- National logo -->
    <div
      class="w-[20px] h-[20px] rounded-full bg-grey-skeleton max-sm:w-[15px] max-sm:h-[15px]"
    ></div>

    <!-- Name and short name -->
    <div class="flex-1">
      <div class="w-[60%] h-[16px] bg-grey-skeleton rounded mb-2"></div>
      <div class="w-[40%] h-[14px] bg-grey-skeleton rounded"></div>
    </div>

    <!-- Position -->
    <div class="w-[40px] h-[20px] bg-grey-skeleton rounded"></div>
  </div>
  }
</div>
